// QuestionPreview.js
import { useState, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { cleanQuestions } from "./Utility/cleanQuestion";
import { uploadAllQuestionMedia, downloadData, createTest, insertResources, createCorrections } from "../../Backend/uploadService";
import { getTestData, getRowsofQuestion } from "../../Backend/Utility/Utilities";
import MessageDialog from "../Utility/LinkBox";
import PreviewScreen from "./PreviewScreen";
import { UploadProgressOverlay } from "../Utility/UploadProgressOverlay";


const MOBILE_BREAKPOINT = 768;

export default function QuestionPreview() {
  const location = useLocation();
  const navigate = useNavigate();

  const { state } = location;
  const rawQuestions = state?.rawQuestions;
  const onShare = state?.onShare;

  const questions = useMemo(() => rawQuestions ? cleanQuestions(rawQuestions) : [], [rawQuestions]);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [showMessage, setMessage] = useState(null); // null instead of false
  const [isMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  const [uploadSteps, setUploadSteps] = useState(null);
  // null = not uploading, array = uploading

  useEffect(() => {
    if (!state || !state.rawQuestions) {
      alert("No data found. Try Loading Again...");
      navigate(-1);
    }
  }, [state, navigate]);


  // Early returns AFTER all hooks
  if (!rawQuestions) return null;

  if (questions.length === 0) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "'Nunito', sans-serif",
        fontSize: 18,
        color: "#999",
      }}>
        No questions to preview.
      </div>
    );
  }

  const question = questions[questionIndex];
  const handleSubmit = async () => {
    setUploadSteps([
      { label: "Uploading media", status: "loading" },
      { label: "Creating test", status: "pending" },
      { label: "Saving resources", status: "pending" },
    ]);

    const result = await uploadAllQuestionMedia(questions);
    if (!result.success) {
      setUploadSteps(null);
      setMessage({ vibe: "failure", title: "Media Upload Failed!", message: result.msg });
      return;
    }

    setUploadSteps([
      { label: "Uploading media", status: "done" },
      { label: "Creating test", status: "loading" },
      { label: "Saving resources", status: "pending" },
    ]);

    const testData = getTestData(result.questions);
    const test_result = await createTest(testData);
    if (!test_result.success) {
      setUploadSteps(null);
      setMessage({ vibe: "failure", title: "Test Creation Failed!", message: test_result.msg });
      return;
    }

    setUploadSteps([
      { label: "Uploading media", status: "done" },
      { label: "Creating test", status: "done" },
      { label: "Saving resources", status: "loading" },
    ]);

    const testId = test_result.testId;
    const resources = getRowsofQuestion(result.questions, testId);
    const res_upload_result = await insertResources(resources);

    if (!res_upload_result.success) {
      setUploadSteps(null);
      setMessage({ vibe: "failure", title: "Test Upload Failure!", message: res_upload_result.msg });
      return;
    }
    const correction_upload_result = await createCorrections(result.questions);

    if (!correction_upload_result.success) {
      setUploadSteps(null);
      setMessage({ vibe: "failure", title: "Data Upload Failure!", message: res_upload_result.msg });
      return;
    }

    setUploadSteps(null);
    setMessage({ vibe: "success", title: "Share this test", message: `https://useocul.com/test/${testId}` });
  };

  return (
    <>
      <PreviewScreen
        question={question}
        onPrev={() => setQuestionIndex(Math.max(0, questionIndex - 1))}
        onNext={() => setQuestionIndex(Math.min(questions.length - 1, questionIndex + 1))}
        onShare={handleSubmit}
      />
      {showMessage && (
        <MessageDialog
          vibe={showMessage.vibe}
          title={showMessage.title}
          message={showMessage.message}
          onClose={() => setMessage(null)}
        />
      )}
      {uploadSteps && <UploadProgressOverlay steps={uploadSteps} />}
    </>
  );
}

